module.exports = __webpack_public_path__ + "media/directory/comment_icon_hover-8c022257.svg";